<template>
  <v-container fluid>
    <v-row justify="space-around">
      <v-col cols="11">
        <v-card>
          <v-container fill-height fluid>
            <v-row fill-height>
              <v-col cols="12" align-end>
                <div v-if="typeof getProject.title !== 'undefined'">
                  <span class="headline">{{ getProject.title }}</span>
                </div>
              </v-col>
            </v-row>
          </v-container>

          <!-- Left Side Bar -->
          <v-row>
            <v-col cols="3">
              <v-card height="415px">
                <v-list class="pt-0" dense>
                  <v-card-title primary-title>
                    <div>
                      <p>Creado por:</p>
                      <div v-if="typeof getProject !== 'undefined'">
                        <p>{{ getProject.owner.full_name }}</p>
                      </div>
                    </div>
                  </v-card-title>
                </v-list>
              </v-card>
            </v-col>

            <!-- New Topic right side-->
            <v-col cols="9">
              <v-card class="mr-2">
                <form class="pa-2">
                  <v-text-field v-model="title" label="Titulo del Topico" :counter="30" required />
                  <div v-if="typeof getProject !== 'undefined'">
                    <p>
                      Se posteara en
                      <a>{{ getProject.title }}</a>
                    </p>
                  </div>

                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <trumbowyg
                          v-model="content"
                          :config="config"
                          class="form-control"
                          name="content"
                        ></trumbowyg>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-btn color="light-blue" @click="edit_topic">Editar</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>

                  <!-- <v-btn color="success" @click="preview">Revisar</v-btn> -->
                </form>
              </v-card>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-btn class="white--text light-blue" @click="return_project">Regresar a Menu</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbarTitle" :right="true" :timeout="3000" :top="true">
      {{ message_snack }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarContent" :right="true" :timeout="3000" :top="true">
      {{ message_snack_content }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
// import ProjectList from "../../components/helper/Project/ProjectList.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { firestore } from "firebase";
import Trumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/ui/trumbowyg.css";
import jQuery from "jquery";

export default {
  components: {
    Trumbowyg
  },
  data() {
    return {
      el: null,
      content: "",
      config: {
        autogrow: true,
        removeformatPasted: true,
        semantic: false
      },
      title: "",
      snackbarTitle: false,
      message_snack: "",
      snackbarContent: false,
      message_snack_content: "",
      documents: [
        {
          name: "Documento1.docx",
          url: "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
        },
        {
          name: "Documento2.docx",
          url: "https://cdn.vuetifyjs.com/images/cards/docks.jpg"
        },
        {
          name: "Documento3.docx",
          url: "https://cdn.vuetifyjs.com/images/cards/docks.jpg"
        }
      ]
    };
  },
  methods: {
    ...mapActions("projects", ["onceProject"]),
    ...mapActions("discussion", ["saveTopic"]),
    ...mapMutations("discusssion", ["insertTopic"]),
    edit_topic() {
      if (this.title == "") {
        this.message_snack = "Por favor ingrese el título del tópico";
        this.snackbarTitle = true;
        return;
      } else if (this.content == "" || this.content == null) {
        this.message_snack_content =
          "Por favor ingrese el contenido del tópico";
        this.snackbarContent = true;
        return;
      }
      const projectID = this.$route.params.project_id;
      const topicID = this.$route.params.topic_id;
      // eslint-disable-next-line no-unused-vars
      const topico = {
        title: this.title,
        description: this.content
      };
      firestore()
        .collection("Project")
        .doc(projectID)
        .collection("Topic")
        .doc(topicID)
        .update(topico)
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("El tópico fue actualizado!");
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log("Ocurrió un error al editar el tópico: " + error);
        })
        .finally(() => {
          this.$router.push({
            path: `/dashboard/${this.$route.params.project_id}/${this.$route.params.owner}/topicsTab`
          });
        });
    },
    return_project() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.project_id}/${this.$route.params.owner}`
      });
    },
    getTopicData() {
      var projectID = this.$route.params.project_id;
      var topicID = this.$route.params.topic_id;
      var _this = this;
      firestore()
        .collection("Project")
        .doc(projectID)
        .collection("Topic")
        .doc(topicID)
        .onSnapshot(function(doc) {
          let tmp = doc.data();
          _this.title = tmp.title;
          _this.content = tmp.description;
        });
    },
    // eslint-disable-next-line no-unused-vars
    loadImage: function(command) {
      // TODO
    },

    preview() {
      // TODO
    }
  },
  created() {
    // eslint-disable-next-line no-unused-vars
    this.getTopicData();
    this.el = jQuery(this.$el);
  },
  computed: {
    ...mapGetters("projects", ["getProject"]),
    ...mapGetters("user", ["showProfile"]),
    ...mapState("dates", ["now"])
  },
  mounted() {
    this.onceProject();
  },
  beforeDestroy() {
    this.el.trumbowyg("destroy");
  }
};
</script>

<style>
.is-active {
  border-color: grey;
  border-style: solid;
  border-width: 1px;
}
</style>
